export default [
    {
        id: 1,
        name_ca: 'Jardí o zones verdes',
        name_en: 'Garden, green areas',
        name_es: 'Jardín, zonas verdes'
    },
    {
        id: 2,
        name_ca: 'Piscina, jardins',
        name_en: 'Swimming-pool, gardens',
        name_es: 'Piscina, jardines'
    },
    {
        id: 3,
        name_ca: 'Vials d\'accés, aparcament, maniobra de càrrega i descàrrega',
        name_en: 'Acces ways, parking, loading areas',
        name_es: 'Viales de acceso, aparcamiento, maniobra de carga y descarga'
    },
    {
        id: 4,
        name_ca: 'Zona infantil',
        name_en: 'Children\'s area',
        name_es: 'Zona infantil'
    },
    {
        id: 4,
        name_ca: 'Zones esportives',
        name_en: 'Sports areas',
        name_es: 'Zonas deportivas'
    },
    {
        id: 5,
        name_ca: 'No n\'hi ha',
        name_en: 'There is none',
        name_es: 'No hay'
    },
    {
        id: 999,
        name_ca: 'Altra',
        name_en: 'Other',
        name_es: 'Otra'
    }
]



// WEBPACK FOOTER //
// ./src/options/plot_free_area_usages.js